import { useState } from 'react';
import { useT } from '@/i18n';

// Shown only on builds made with VITE_CHANNEL=dev (the main branch → dev.assetlist.app). Tells the user the build
// may be unstable, that a reload is safe because everything lives in this browser, and where the stable site is.
// Dismissal lasts for the tab: every new visit sees it again.
const CHANNEL = import.meta.env.VITE_CHANNEL as string | undefined;
const KEY = 'assetlist.devBannerDismissed';

export function DevBanner() {
  const { t } = useT();
  const [hidden, setHidden] = useState(() => {
    try {
      return sessionStorage.getItem(KEY) === '1';
    } catch {
      return false;
    }
  });
  if (CHANNEL !== 'dev' || hidden) return null;
  const dismiss = () => {
    setHidden(true);
    try {
      sessionStorage.setItem(KEY, '1');
    } catch {
      // session storage unavailable: the banner simply returns next render
    }
  };
  return (
    <div className="devBanner" role="status">
      <span>
        {t('dev.banner')} <a href="https://assetlist.app">assetlist.app</a>
      </span>
      <button type="button" className="devBannerClose" onClick={dismiss} aria-label={t('common.close')}>×</button>
    </div>
  );
}
